module.exports = __webpack_public_path__ + "media/bootstrap-icons/moon-42817275.svg";